import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/cn';
export function Table({ children, className }) {
    return (_jsx("div", { className: cn('overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900', className), children: _jsx("div", { className: "overflow-x-auto", children: _jsx("table", { className: "w-full text-sm", children: children }) }) }));
}
export function THead({ children }) {
    return (_jsx("thead", { className: "bg-slate-50/80 text-left text-meta text-slate-500 dark:bg-slate-800/50 dark:text-slate-400", children: children }));
}
export function TBody({ children }) {
    return _jsx("tbody", { className: "divide-y divide-slate-100 dark:divide-slate-800/70", children: children });
}
export function TR({ children, onClick, className, }) {
    return (_jsx("tr", { onClick: onClick, className: cn('transition-colors', onClick && 'cursor-pointer hover:bg-brand-50/40 dark:hover:bg-brand-950/20', className), children: children }));
}
export function TH({ children, className, scope, ariaSort, }) {
    return (_jsx("th", { scope: scope ?? 'col', "aria-sort": ariaSort, className: cn('px-4 py-3', className), children: children }));
}
export function TD({ children, className }) {
    return _jsx("td", { className: cn('px-4 py-3.5 align-middle', className), children: children });
}
export function EmptyState({ message, cta, icon, }) {
    return (_jsxs("div", { className: "flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white py-16 text-center dark:border-slate-700 dark:bg-slate-900", children: [_jsx("div", { className: "mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500", children: icon ?? _jsx(Inbox, { className: "h-6 w-6" }) }), _jsx("div", { className: "text-sm text-slate-500", children: message }), cta && _jsx("div", { className: "mt-4", children: cta })] }));
}
